import { Component, OnInit, OnDestroy, inject } from '@angular/core'
import { Organization } from '../organization-article.model'
import { BaseArticleComponent } from 'src/app/shared/components/base-article-component/base-article-component'
import { SavedSearchService } from 'src/app/services/saved-search.service'
import { AsyncPipe } from '@angular/common'
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap'
import { NgScrollbarModule } from 'ngx-scrollbar'
import { LoadingStatusComponent } from '../../../shared/components/loading-status/loading-status.component'
import { OrganizationOverviewComponent } from 'src/app/shared/components/organization-overview/organization-overview.component'
import { DownloadDialogComponent } from 'src/app/shared/components/download-dialog/download-dialog.component'

@Component({
    selector: 'app-organization-article',
    templateUrl: './organization-article.component.html',
    styleUrls: ['./organization-article.component.scss'],
    imports: [
        LoadingStatusComponent,
        NgScrollbarModule,
        NgbNavModule,
        AsyncPipe,
        OrganizationOverviewComponent,
        DownloadDialogComponent
    ]
})
export class OrganizationComponent extends BaseArticleComponent<Organization> implements OnInit, OnDestroy {
    protected override savedSearchService = inject(SavedSearchService)

    public creditorMode = false
}
